/** 各业务入口在此注册；公共任务组件不推断业务类型。 */
const inspectionEntry = (action, vm) => vm.$router.push({
  path: '/om/inspection/InspectionRecordList',
  query: action.params || {}
})

const manualCheckEntry = (action, vm) => vm.$router.push({
  path: '/om/report/ManualCheckList',
  query: action.params || {}
})

export const maintenanceEntries = {
  'inspection.record.list': inspectionEntry,
  'inspection.record.detail': inspectionEntry,
  'manual.check.list': manualCheckEntry,
  'manual.check.detail': manualCheckEntry,
  'manual.check.continue': manualCheckEntry
}

export function openMaintenanceAction(action, businessType, vm) {
  // 兼容迁移前的巡检动作，未知业务不可借用此入口。
  const entryKey = action && (action.entryKey ||
    (businessType === 'om_inspection_record' && action.actionCode === 'VIEW' ? 'inspection.record.list' : null))
  const entry = maintenanceEntries[entryKey]
  if (!entry || !['VIEW', 'CREATE', 'CONTINUE'].includes(action.actionCode)) {
    vm.$message.info((action && action.tip) || '该业务入口尚未接入当前终端')
    return Promise.resolve(false)
  }

  // 同步当前站点状态到全局缓存和事件派发
  if (action && action.params && action.params.siteId) {
    const sId = String(action.params.siteId)
    sessionStorage.setItem('pipeId', sId)
    sessionStorage.setItem('siteId', sId)
    if (typeof vm.resetSetItem === 'function') {
      vm.resetSetItem('siteId', sId)
      if (action.params.siteName) {
        vm.resetSetItem('siteName', action.params.siteName)
      }
    }
  }

  return Promise.resolve(entry(action, vm)).then(() => true).catch(error => {
    if (error && error.name === 'NavigationDuplicated') return true
    vm.$message.error('打开业务页面失败，请重试')
    return false
  })
}
